import apiFetch from '../apiFetch'
export default function (token, conditionNoDocumentalId) {
  return apiFetch({ endPoint: `conditionNoDocumental/condition/${conditionNoDocumentalId}`, method: 'GET', body: null, token: token })
}
